// @flow

import React from 'react';
import styled from 'styled-components';
import type { Node } from 'react';

const UnorderedList = styled.ul`
  margin-inline-start: 2rem;
  margin-bottom: 32px;
`;

type Props = {
  listItems?: Node | string[],
};

const LegalList = ({ listItems, ...rest }: Props) => (
  <UnorderedList {...rest}>
    {listItems.map((listItem, index) => (
      <li key={`ListItem-${index}`}>{listItem}</li>
    ))}
  </UnorderedList>
);

export default LegalList;
